import { AccordionDetails, Grid, useMediaQuery } from "@mui/material";

import { useState } from "react";
import { encodingFromSpanish } from "../App";

export default function GameItem({ branch, odds, i }) {
  // console.log(branch);

  const isDesktop = useMediaQuery("(min-width: 1224px)");

  const urlPrfix = "https://apuestas.codere.mx/es_MX";
  const betSlipPrefix = "https://apuestas.codere.mx/add-selns?lang=es_MX";

  // console.log(`Device: ${isDesktop ? "Desktop" : "Mobile"}`);

  const urlHandler = (game, index) => {
    return `${betSlipPrefix}?addbet=&bet_ref=${game.Mkt[0].Seln[index].Price[0]["@bet_ref"]}`;

    if (window.top.innerWidth > 768)
      return `${betSlipPrefix}?addbet=&bet_ref=${game.Mkt[0].Seln[index].Price[0]["@bet_ref"]}`;
    else
      return `${urlPrfix}/e/${game["@ev_id"]}/${encodingFromSpanish(
        branch[index]["@name"]
      ).replaceAll(" ", "-")}`;
  };

  const [showMore, setShowMore] = useState(true);

  const dateHandler = (date) => {
    const [month, day, year, hours, minutes, seconds] = date.split(/[/\s:]/);

    // Create a Date object using the local parsed date
    const tempDate = new Date(
      `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`
    );
    console.log("date >>");
    console.log(date);

    console.log("fixedDate >>");
    // console.log(fixedDate);

    // const tempDate = new Date(date);

    const options = {
      day: "numeric",
      month: "long",
      hour: "2-digit",
      minute: "2-digit",
    };

    const time = tempDate.toLocaleString("es-sp", options).split(",")[1];

    if (tempDate.getDate() === new Date().getDate()) return `hoy ${time}`;
    else if (tempDate.getDate() === new Date().getDate() + 1)
      return `mañana ${time}`;
    // else return "boy";
    return tempDate.toLocaleString("es-sp", options);
    // return tempDate.toLocaleString("es-sp", options);
  };
  return (
    <>
      {branch.length > 0 && (
        <AccordionDetails className="acc-details-container">
          <div className={`acc-details ${!showMore ? "collapsed" : ""}`}>
            {branch.slice(0, showMore ? 3 : 6).map((game, j) => (
              <div key={j} className="acc-body">
                <p className="date">{dateHandler(game["@start_time"])}</p>

                <Grid
                  style={{
                    justifyContent: `space-${
                      odds[i][j].length === 2 ? "evenly" : "around"
                    }`,
                  }}
                  className="grided"
                  key={j}
                  container
                  spacing={4}
                >
                  <Grid className="names" md={4} xs={4}>
                    <p>{encodingFromSpanish(game["@name"].split(" v ")[0])}</p>
                    <p>{encodingFromSpanish(game["@name"].split(" v ")[1])}</p>
                  </Grid>

                  {odds[i][j].map((_, index) => (
                    <Grid
                      onClick={() =>
                        window.open(urlHandler(game, index), "_blank")
                      }
                      className="odd-grid"
                      key={index}
                      md={odds[i][j].length === 2 ? 3 : 2}
                      xs={3}
                      rel="nofollow"
                    >
                      <p>
                        {index + 1 === 2 && odds[i][j].length > 2
                          ? "x"
                          : index === 2
                          ? index
                          : index + 1}
                      </p>
                      <p>{odds[i][j][index]}</p>
                    </Grid>
                  ))}
                </Grid>
              </div>
            ))}
            {branch.length > 3 && (
              <div onClick={() => setShowMore(!showMore)} className="ver">
                Ver {showMore ? "más" : "menos"}
              </div>
            )}
          </div>
        </AccordionDetails>
      )}
    </>
  );
}
